import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "The range", href: "#range" },
  { label: "What we contribute", href: "#contribute" },
  { label: "Exclusivity", href: "#exclusivity" },
  { label: "Trade data", href: "#trade" },
  { label: "FAQ", href: "#faq" },
];

const LANDING_LINKS = [
  { label: "Home", href: "/" },
  { label: "Ingredients", href: "/ingredients" },
  { label: "Private label", href: "/private-label" },
  { label: "Coffee & hospitality", href: "/coffee-hospitality" },
];

export default function Footer() {
  return (
    <footer className="bg-ink pt-16 pb-8">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div>
            <h3 className="text-cream font-serif text-lg font-semibold tracking-wide">
              MESA BAJA AGROINDUSTRIA S.A.S.
            </h3>
            <p className="mt-3 text-cream/70 text-sm leading-relaxed">
              Km 3 vía Armenia - El edén Bodega 1, Armenia, Quindío, Colombia
            </p>
            <p className="mt-1 text-cream/70 text-sm">NIT 900972460-1</p>
          </div>

          <div>
            <h4 className="text-cream/50 text-xs uppercase tracking-wider font-semibold">
              Contact
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li className="text-cream/80">
                Export enquiries: sara.grisales@mesabaja.com
              </li>
              <li className="text-cream/80">
                Phone / WhatsApp: +57 3104191272
              </li>
              <li className="text-cream/80">
                LinkedIn: https://www.linkedin.com/company/mesa-baja-agroindustria/
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-cream/50 text-xs uppercase tracking-wider font-semibold">
              Navigate
            </h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-cream/80 text-sm hover:text-brand transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-cream/50 text-xs uppercase tracking-wider font-semibold">
              Our solutions
            </h4>
            <ul className="mt-4 space-y-2.5">
              {LANDING_LINKS.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-cream/80 text-sm hover:text-brand transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cream/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-cream/60 text-sm">
            © 2026 Mesa Baja Agroindustria S.A.S. All rights reserved.
          </p>
          <p className="text-cream/40 text-xs max-w-sm leading-relaxed sm:text-right">
            If you received an email from us and would prefer not to hear from
            us again, reply with &apos;unsubscribe&apos; and we will remove your
            details.
          </p>
        </div>
      </div>
    </footer>
  );
}